/* eslint-disable @typescript-eslint/no-explicit-any */
import { addCustomAction } from '@sparkai/monitoring'
import { useCallback } from 'react'

export function useButtonClickVerification() {
  const handleClick = useCallback(
    (
      event: React.MouseEvent<HTMLButtonElement>,
      onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    ) => {
      const isTrusted = (event as any).isTrusted

      if ((event as any).isTrusted) {
        onClick?.(event)
      } else {
        addCustomAction('Bot Identified', { data: { isTrusted } })
      }
    },
    []
  )

  return {
    handleClick,
  }
}
